import Form from '@components/dynamic-form/Form';
import { connect } from 'redux-bundler-react';
import { useNpr, useRequest } from '@stores';
import { getNprForm } from './nprData';
import { useCallback, useMemo } from 'react';
import { RequestType } from '@src/utils/enums';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';

export const NprInformationMetadata = {
  sectionName: `${RequestType.ActivityBasedNoPermitRequired} Information`,
};

const NprInformation = connect(
  'doUpdateNprRequest',
  'selectRequestFormData',
  'selectRequestID',
  'selectVersion',
  ({
    doUpdateNprRequest,
    requestFormData,
    group,
    requestID,
    version,
    stepNo,
    componentID,
    formVersion,
    formVariant,
  }) => {
    const request = requestFormData?.request;
    const requestVariant = formVariant;
    const requestVersion = formVersion ?? request?.formVersion ?? 1;

    const { isFormReadOnly: isReadOnly, updateSection, isSectionValid, getSections } = useRequest();
    const { setNprResult } = useNpr();

    const nprFormArgs = useMemo(
      () => ({ variant: requestVariant, version: requestVersion }),
      [requestVariant, requestVersion]
    );

    const nprFormData = useMemo(() => getNprForm(nprFormArgs), [nprFormArgs]);

    const handleOnChange = (data, isEndConditionMet) => {
      const cleanedData = _omitBy(data, _isNil); // remove nulls
      const { noPermitRequiredID, createdDate, modifiedDate, createdBy, modifiedBy } =
        requestFormData?.request?.noPermitRequireds?.[0] ?? {};

      updateSection(stepNo, { dirty: true });

      const nprDataObj = {
        ...cleanedData,
        createdDate,
        modifiedDate,
        createdBy,
        modifiedBy,
        noPermitRequiredID,
        requestID,
        version: version || 0,
      };

      if (!isEndConditionMet) {
        setNprResult('');
        doUpdateNprRequest({
          ...nprDataObj,
          nprResult: '',
        });
      } else {
        const { nprResult } = useNpr.getState();
        doUpdateNprRequest({
          ...nprDataObj,
          nprResult,
        });
      }
    };

    const handleOnValidationChange = useCallback(
      (isValid) => {
        if (isSectionValid(stepNo) === isValid) {
          return;
        } else {
          updateSection(stepNo, { valid: isReadOnly ? true : isValid });
          if (group) {
            const parentIndex = group?.parentIndex;

            if (!parentIndex) {
              return;
            }
            const currentSections = getSections();
            const isGroupValid = group?.indexes.every((index) => currentSections[index]?.valid);

            updateSection(parentIndex, { valid: isGroupValid });
          }
        }
      },
      [stepNo, isReadOnly, group, updateSection, isSectionValid, getSections]
    );

    return (
      <Form
        componentID={componentID}
        formData={nprFormData}
        isInformation={false}
        isReadOnly={isReadOnly}
        onChange={handleOnChange}
        onValidationChange={handleOnValidationChange}
        stepNo={stepNo}
      />
    );
  }
);

NprInformation.metadata = NprInformationMetadata;

export default NprInformation;
